import tmhRequest from "@/config/tmhRequest";

export default {
  searchListCustomerLog: function(data) {
    return tmhRequest({
      url: "/system/tmh/customerlog/searchlistcustomerlog",
      method: "post",
      params: data
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/tmh/system/customerlog.js